/**
 * Created by Desarrollo KJ on 20/3/2017.
 */
import { Injectable } from '@angular/core';
import { RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class Configuration {
  public Server: string = 'https://tienda-ve.grupojrca.com:9000/';
  //public Server: string = 'http://192.168.0.27:9000/';
  public ApiUrl: string = 'v1/front/';
  public ServerWithApiUrl:string = this.Server+this.ApiUrl;
  public header:Headers;
  public resquestOption: RequestOptions;
  public paisConfiguration : any = {};
  public paisDefault:number = 2;

  constructor (){
    //this.Server = 'http://api.grupojrca.com:9000/';
    this.header = new Headers();
    this.header.append('x-access-llave','123456789');

    if(localStorage.getItem('login')){
      let user = JSON.parse(localStorage.getItem('login'));
      this.header.append('x-access-token',user.token);
    }

    this.resquestOption = new RequestOptions({ headers: this.header});

    if(localStorage.getItem('pais')){
      this.paisConfiguration = JSON.parse(localStorage.getItem('pais'));
    }
    else {
      this.paisConfiguration = {
        idPais: 1,
        nombre: "Venezuela",
        url: "ve",
        correo: "contactos@grupojrca.com",
        moneda: "Bolivares",
        codigoInternacional: "VEF",
        simbolo: "BS",
        zonaHoraria: "American/Pacific",
        cambioDolar: 1,
        direccion: "Dirección Chile",
        rif: "v-1564654",
        idioma: "es"
      };
      localStorage.setItem('pais', JSON.stringify(this.paisConfiguration))
    }

  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/services/config.service.ts